<template>
  <div>
    <!--顶部按钮-->
    <div class="app-container">
      <div style="height: 30px">
        <vxe-button v-auth="`EXPORT`" @click="deriveFun">导出</vxe-button>
        <div style="float: right; color: #848484; display: flex; line-height: 28px">
          <div v-if="!showdiv">
            <a-input v-model="queryCondition.materialCode" placeholder="物料号" clearable style="width: 150px; margin-right: 1rem" @keyup.enter.native="queryByPage()" />
            <a-input v-model="queryCondition.materialName" placeholder="物料名称" clearable style="width: 150px; margin-right: 1rem" @keyup.enter.native="queryByPage()" />
          </div>
          <div>
            <vxe-button v-if="!showdiv" status="primary" @click="queryByPage(1)">搜索</vxe-button>
            <vxe-button v-if="!showdiv" type="info" class="filter-search-item" @click="resetForm">重置</vxe-button>
            <vxe-button type="warning" @click="cb">
              {{ showdiv ? '收起' : '更多选项' }}
            </vxe-button>
          </div>
        </div>
      </div>
      <!--筛选拓展-->
      <div style="margin-top: 10px">
        <a-collapse>
          <div v-if="showdiv">
            <div v-if="showdiv">
              <SiftMaterial :data.sync="queryCondition" :type="siftType" :list="SelectLists" />
              <br>
              <div slot="footer" style="text-align: center; padding-bottom: 10px">
                <vxe-button type="info"  @click="resetForm">重置</vxe-button>
                <vxe-button status="primary" @click="queryByPage(1)">搜索</vxe-button>
              </div>
            </div>
          </div>
        </a-collapse>
      </div>
      <!--table列表-->
      <vxe-table
        ref="xTable"
        :loading="listLoading"
        :align="allAlign"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        border
        show-header-overflow
        show-overflow
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="tableData"
        @sort-change="listSortMethod"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column field="materialCode" title="物料号" width="200" />
        <vxe-column field="materialName" title="物料名称" width="300" />
        <vxe-column field="materialType" title="物料类型" width="100">
          <template #default="{ row }">
            <span v-if="row.materialType === '1'">销售物料</span>
            <span v-else-if="row.materialType === '2'">礼品物料</span>
            <span v-else-if="row.materialType === '3'">宣传物料</span>
            <span v-else-if="row.materialType === '4'">其它</span>
            <span v-else-if="row.materialType === '5'">产品资料</span>
            <span v-else-if="row.materialType === '6'">手册</span>
            <span v-else>其它</span>
          </template>
        </vxe-column>
        <vxe-column field="price" title="申领价（元）" width="120" align="center" sortable>
          <template #default="{ row }">
            {{ row.price | toThousandNumFilter }}
          </template>
        </vxe-column>
        <vxe-column field="prodPrice" title="制作价（元）" width="120" align="center" sortable>
          <template #default="{ row }">
            {{ row.prodPrice | toThousandNumFilter }}
          </template>
        </vxe-column>
        <vxe-column field="unit" title="单位" width="100" />
        <!-- <vxe-column field="supplier" title="供应商" width="100" /> -->
        <!-- <vxe-column field="warehouse" title="所属仓库" width="150">
          <template #default="{ row }">
            <span v-if="row.warehouse === '1'">外部仓库</span>
            <span v-else-if="row.warehouse === '2'">内部仓库</span>
          </template>
        </vxe-column> -->
        <vxe-column field="nums" title="入库数量" width="100" sortable/>
        <vxe-column field="totalPrice" title="入库总金额" width="100" align="center" sortable>
          <template #default="{ row }">
            {{ (row.prodPrice * row.nums) | toThousandNumFilter }}
          </template>
        </vxe-column>
        <vxe-column field="inTime" title="入库时间" width="150" sortable />
        <vxe-column field="operator" title="操作人" width="100" />
      </vxe-table>
      <vxe-pager
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />
    </div>
    <!--导出对话框 -->
    <a-modal title="选择导出项" v-model="dialogVisible" width="400px">
      <a-radio-group v-model="ExportItem">
        <a-radio :value="0">导出全部</a-radio>
        <a-radio :value="1">导出当前页</a-radio>
        <a-radio :value="2" :disabled="disabled">导出已选择项</a-radio>
      </a-radio-group>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="dialogVisible = false">取 消</vxe-button>
        <vxe-button status="primary" :loading="outExcelButtonLocading" @click="exportXlsxFun">确 定</vxe-button>
      </span>
    </a-modal>
  </div>
</template>

<script>
import { findInList, exportInWarehouse } from '@/api/material'
import SiftMaterial from './components/SiftMaterial.vue'
import { outExcel } from '@/utils/Excel/outExcel'

const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}

export default {
  // 广宣物料管理/广宣物料入库,
  name: 'PublicizeMaterialInWarehouse',
  components: {
    SiftMaterial
  },
  data() {
    return {
      showdiv: false,
      pagination: Object.assign({}, defaultPagination),
      listLoading: false,
      base: {},
      tableData: [],
      allAlign: 'center',
      queryCondition: {},
      // 筛选条件框类型 0物料维护，1入库，2出库
      siftType: 1,
      // 导出对话框
      dialogVisible: false,
      disabled: true, // 已选择按钮是否禁用
      outExcelButtonLocading: false,
      ExportItem: 0,
      SelectLists: {},
      sort: 'inTime desc'
    }
  },

  watch: {},
  created() {
    // 获取表格数据
    this.queryByPage()
    // 获取下拉框列表
    this.SelectListFun()
  },
  mounted() {},
  methods: {
    deriveFun() {
      this.dialogVisible = true
      // 判断是否选中
      this.disabled = this.$refs.xTable.selection.length < 1
    },
    // 导出表格
    async exportXlsxFun() {
      // 需要导出的数据
      let data = []
      const typeMap = new Map([
        ['1', '销售物料'],
        ['2', '礼品物料'],
        ['3', '宣传物料'],
        ['4', '其它']
      ])
      // const warehouse = new Map([
      //   ['1', '外部仓库'],
      //   ['2', '内部仓库']
      // ])
      this.outExcelButtonLocading = true
      if (this.ExportItem == 0) {
        if (this.pagination.total > 10000) {
          this.$message.warning('导入' + this.pagination.total + '条，过程可能持续数分钟。')
        }
        let data = { page: 1, limit: this.pagination.total, sort: this.sort, ...this.queryCondition }
        exportInWarehouse(data).then(val => {
          this.$exportExcelData(val, `广宣物料入库表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
          // 关闭弹窗
          this.dialogVisible = false
          this.outExcelButtonLocading = false
        })
        return
      } else if (this.ExportItem == 1) {
        data = this.tableData
      } else if (this.ExportItem == 2) {
        data = this.$refs.xTable.selection
      }
      let table = []
      for (var i = 0; i < data.length; i++) {
        var params = {
          物料号: data[i].materialCode,
          物料名称: data[i].materialName,
          物料类型: typeMap.get(data[i].materialType),
          单位: data[i].unit,
          申领价: data[i].price,
          制作价: data[i].prodPrice,
          // 供应商: data[i].supplier,
          // 所属仓库: warehouse.get(data[i].warehouse),
          入库数量: data[i].nums,
          入库总金额: data[i].prodPrice * data[i].nums,
          入库时间: data[i].inTime,
          操作人: data[i].operator
        }
        table[i] = params
      }
      const wch = [15, 20, 15, 15, 15, 15, 15, 15, 15, 15, 20, 15]
      outExcel('广宣物料入库表', table, wch)
      // 关闭弹窗
      this.dialogVisible = false
      this.outExcelButtonLocading = false
    },
    // 分页
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      if (pageSize != this.pagination.size) this.pagination.current = 1
      this.pagination.size = pageSize
      this.queryByPage()
    },
    listSortMethod({ sortList }) {
      let sort = ''
      for (let i = 0; i < sortList.length; i++) {
        if (i !== 0) {
          sort = sort + ','
        }
        sort = sort + sortList[i].property + ' ' + sortList[i].order
      }
      this.sort = sort
      this.queryByPage()
    },
    // 重置筛选
    resetForm() {
      this.queryCondition = {}
      this.queryByPage(1)
    },
    // 获取下拉列表
    SelectListFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['PromotionMaterialType', 'PromotionStockType']).then(v => {
        this.SelectLists = v
      })
    },
    // 搜索表格数据
    async queryByPage(e) {
      if (e) this.pagination.current = e
      // 筛选条件
      let queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        sort: this.sort,
        ...this.queryCondition
      }
      this.listLoading = true //开启加载动画
      findInList(queryData).then(res => {
        if (res.code === 1 && res.data) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error('搜索失败')
        }
        this.listLoading = false
      })
    },
    cb() {
      this.showdiv = !this.showdiv
    },
    // 详细按钮
    inspectFun(row) {
      this.$router.push('/financial_management/tripartiteFinancing/tripartiteAgreementDetails/' + row.taid)
    }
  }
}
</script>
<style lang="less" scoped>
.a-input--medium .a-input__inner {
  height: 30px;
}
span {
    font-size: 12px;
}
/deep/ .ant-collapse {
  border: none;
  background-color: #fff;
}
</style>
